import React, { useEffect, useState } from 'react';
import { Badge, Select } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/store';
import {
  useIndicatorsQuery,
  // useIndicatorsQuery,
  useOrganizationsQuery,
  useSetCurrentOrganizationMutation,
} from 'app/services/edpApiV1/viewer';
import { viewerModel } from 'entities/viewer';
import { uiModel } from 'entities/ui';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { getColors } from 'shared/helpers/utils';
import {
  getAllAvailableOrganizations,
  getOrganizations,
  organizationsActions,
} from 'entities/organizations/model/organizations';
import { actions, selectors } from 'entities/organizations/model/setOrganization';
import style from './index.module.scss';

type Organization = {
  id: string | null;
  name: string | null;
}[];

const { Option } = Select;
const ALL_ORGS = 'all';

const Organizations: React.FC = () => {
  const colors = getColors();
  const [organizationsList, setOrganizationsList] = useState<Organization>();
  const meOrganizationId = useAppSelector(viewerModel.me.selectors.getMeOrganizationId);
  const [orgId, setOrgId] = useState<string>(meOrganizationId);
  const dispatch = useAppDispatch();
  const { data, isLoading } = useOrganizationsQuery(null);
  const [trigger] = useSetCurrentOrganizationMutation({ fixedCacheKey: 'setCurrentOrganization' });
  const { organizations } = useAppSelector(getOrganizations);
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const { data: indicatorsData, refetch } = useIndicatorsQuery({ allAvailableOrganizations });

  const onSelectOrganization = (id: string) => {
    if (id === ALL_ORGS) {
      dispatch(organizationsActions.setAllOrganizations(true));
    } else {
      dispatch(organizationsActions.setAllOrganizations(false));
      trigger({ id });
      setOrgId(id);
    }

    dispatch(uiModel.VacationSchedule.actions.resetFilters());
  };

  useEffect(() => {
    setOrgId(meOrganizationId);
    dispatch(uiModel.VacationSchedule.actions.isUploadTo1S(false));
    refetch();
  }, [meOrganizationId]);

  useEffect(() => {
    if (data) {
      setOrganizationsList(data);
    }
  }, [data]);

  return (
    <div className={style.organizations}>
      {orgId && organizationsList ? (
        <>
          {indicatorsData?.organizations.length !== 0 && (
            <ExclamationCircleFilled style={{ color: colors.clrPrimary, fontSize: 20 }} />
          )}
          <Select
            defaultValue={orgId}
            onSelect={onSelectOrganization}
            style={{ width: 400 }}
            bordered={false}
            optionLabelProp="label"
            loading={isLoading}
          >
            {organizationsList?.map(el => {
              return (
                <Option key={el?.id} value={el?.id} label={el?.name}>
                  <div className={`${style.option} ${el.id === orgId ? style.active : ''}`}>
                    <span className={style.organizationName}>{el?.name}</span>
                    <Badge
                      count={indicatorsData?.organizations.find(item => item.organizationId === el.id)?.quantity}
                      overflowCount={99}
                    />
                  </div>
                </Option>
              );
            })}
            <Option key={ALL_ORGS} value={ALL_ORGS} label={'Все'}>
              <div className={`${style.option} ${orgId === ALL_ORGS ? style.active : ''}`}>
                <span className={style.organizationName}>{'Все'}</span>
                <Badge
                  count={indicatorsData?.organizations.reduce((acc, item) => {
                    const orgPermit = organizations.organizations.find(elem => elem.id === item.organizationId);
                    if (orgPermit) {
                      return (acc += item.quantity);
                    }
                    return acc;
                  }, 0)}
                  overflowCount={99}
                />
              </div>
            </Option>
          </Select>
        </>
      ) : (
        'Организация'
      )}
    </div>
  );
};

export default Organizations;
